var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafariPinnedTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "291.000000pt",
    height: "291.000000pt",
    viewBox: "0 0 291.000000 291.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.11, written by Peter Selinger 2001-2013\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,291.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1247 2895 c-341 -56 -613 -197 -844 -439 -193 -201 -313 -431 -374 -716 -33 -151 -33 -419 0 -570 65 -302 186 -527 400 -741 214 -214 439 -335 741 -400 151 -33 419 -33 570 0 302 65 527 186 741 400 214 214 335 439 400 741 33 151 33 419 0 570 -65 302 -186 527 -400 741 -213 213 -441 336 -736 399 -132 28 -374 35 -498 15z m300 -450 c190 -56 251 -309 109 -447 -59 -58 -100 -73 -191 -73 -69 0 -86 4 -127 27 -206 122 -176 413 51 494 48 17 97 17 158 -1z m20 -680 c63 -32 100 -79 124 -157 17 -55 19 -100 19 -547 0 -537 -2 -558 -61 -625 -16 -19 -51 -43 -76 -52 -53 -21 -152 -23 -205 -5 -47 15 -113 88 -127 137 -7 25 -11 216 -11 545 0 574 0 574 73 654 71 78 170 96 264 50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariPinnedTab);
export default __webpack_public_path__ + "static/media/safari-pinned-tab.55477ba5a3c649fd3411d01d936d4e4c.svg";
export { ForwardRef as ReactComponent };